import React from 'react';
import styled from 'styled-components';
import Img from './Img';
import {breakPoint} from '../styles/var';
import {NoStyleButton} from './Button';

import img_btn_1 from '../assets/img/PC2-6-1.png';
import img_btn_2 from '../assets/img/PC2-6-2.png';
import fbShareDialog from '../utils/fbShareDialog';




const CardStyles = styled.div`
  width: 100%;
  .avatar {
    max-width: 24rem;
    margin-right: auto;
    margin-left: auto;
  }
  .content {
    list-style: none;
    padding-left: 0;
    span {
      margin-left: .8rem;
    }
  }
  .btns {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  @media (max-width: ${breakPoint.smMin}) {
    .content {
      span {
        margin-left: .4rem;
      }
    }
  }
`


const Card = ({info, category, vote, handleShowModal, ...props}) => {
  const {name, picUrl} = info;
  return (
    <CardStyles {...props}>
      <Img src={picUrl} wrapProps={{className: "avatar"}} rounded={true}/>
      <ul className="content center">
        <li>{name}</li>
        <li>#{category}</li>
      </ul>
    </CardStyles>
  )
}

export default Card;
